<template>
  <div class="c-board-card">
    <div v-if="isShowHeader" class="header">
      <slot name="header">
        <div class="header__title">
          <slot name="title">
            <div class="text">{{ title }}</div>
          </slot>
        </div>
        <div class="header__extra">
          <slot name="extra">
            <div v-if="innerExtra.label" class="link" @click="handleExtraLinkClick">
              <span>{{ innerExtra.label }}</span>
              <i v-if="!innerExtra.iconAttrs?.hidden" v-bind="innerExtra.iconAttrs" class="el-icon-arrow-right"></i>
            </div>
          </slot>
        </div>
      </slot>
    </div>
    <div class="body">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { _, ref, watch, computed, useHostAppInstance, onMounted, useSlots } from '@zto/zpage'

const app = useHostAppInstance()

const props = withDefaults(
  defineProps<{
    title?: string
    extra?: any
    header?: any
    model?: any
    contextData?: any
  }>(),
  {}
)

const slots = useSlots()

const isShowHeader = computed(() => {
  if (props.title || slots.title) return true
  if ((props.extra && props.extra.hidden !== false) || slots.extra) return true
  if ((props.header && props.header.hidden !== false) || slots.header) return true

  return false
})

const innerExtra = computed(() => {
  const extra = props.extra || {}

  let iconAttrs: any = {}

  let icon = extra.icon
  if (_.isNil(icon) || icon === true) {
    icon = 'arrow-right'
  }

  if (icon === false) {
    iconAttrs.hidden = true
  } else {
    if (_.isString(icon)) {
      iconAttrs.class = `el-icon-${icon}`
    } else {
      iconAttrs = { ...icon }
    }
  }

  return { ...extra, iconAttrs }
})

function handleExtraLinkClick() {
  const link = innerExtra.value.link

  if (!link) return

  app.router.goto(link)
}
</script>

<style lang="scss" scoped>
.c-board-card {
  background: white;
  border-radius: 8px;
  padding: 20px;

  .header {
    height: 40px;
    display: flex;
    align-items: center;
    margin-top: -10px;

    &__title {
      flex: 1;
      font-size: 18px;
      font-weight: 600;
      color: #212533;
    }

    &__extra {
      .link {
        color: #666;
        font-weight: 400;
        font-size: 14px;
        cursor: pointer;

        i {
          font-weight: 700px;
        }

        &:hover {
          color: var(--link-color);
        }
      }
    }
  }
}
</style>
